// Etiquetas en una sola línea: la primera y «+N»; la lista completa va en el tooltip.
import type { ReactNode } from 'react';
import { Badge } from '@/kit';
import { cn } from '@/lib/cn';

export interface OneLineTagsProps {
    items: readonly string[];
    /** Lo que se pinta sin etiquetas. */
    empty?: ReactNode;
    renderTag?: (tag: string) => ReactNode;
    className?: string;
}

function defaultTag(tag: string): ReactNode {
    return (
        <Badge variant="secondary" size="xs">
            {tag}
        </Badge>
    );
}

export function OneLineTags({
    items,
    empty = null,
    renderTag = defaultTag,
    className,
}: OneLineTagsProps) {
    if (items.length === 0) return <>{empty}</>;
    const [first, ...rest] = items;
    return (
        <span
            title={items.join(', ')}
            className={cn('inline-flex max-w-full items-center gap-1 whitespace-nowrap', className)}
        >
            <span className="min-w-0 truncate">{renderTag(first)}</span>
            {rest.length > 0 ? (
                <span className="shrink-0 text-[10px] font-semibold text-muted-foreground">
                    +{rest.length}
                </span>
            ) : null}
        </span>
    );
}
